<template>
  <div>
    <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
    <div v-loading="loading">
      <pt-lab-order-detail class="pt-lab-order-detail__withData" :task="task" :tasks="tasks" :statuses="statuses" :order="order" :logs="logs" :sampleRecollectLogs="sampleRecollectLogs" @on-reload="load" @handle-loding="handleLoding"></pt-lab-order-detail>
    </div>

  </div>
</template>
<script>
import {
  formatDateObject
} from '@/utils/formUtils'
import {
  formatOperationLog
} from 'enumeration/lab-order.js'
import orderflowHelper from '@/config/order'
import PtLabOrderDetail from './index'
export default {
  name: 'pt-lab-order-detail__withData',
  components: {
    'pt-lab-order-detail': PtLabOrderDetail
  },
  props: {
    // 路由参数 - 产品id
    id: {
      type: String,
      required: true
    },
    // 路由参数 - 产品数据，父组件可以直接传入整个产品对象绑定到详情页，也可以不传。
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // 用于绑定的产品数据对象
      order: this.value ? this.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      statuses: [],
      // 当前的异常任务
      task: null,
      tasks: null,
      relevantFiles: [],
      logs: [],
      samplePlates: [],
      sampleRecollectLogs: []
    }
  },
  watch: {
    id (val) {
      this.load()
    }
  },
  methods: {
    // 加载详情数据
    load () {
      // this.order = {
      //     orderStatusEnum:'LAB_SAMPLES_RECEIVED',
      //     nextOrderAction:'DAI_FEN_PAI'
      //   }
      //   this.statuses = [{
      //     action:'LAB_SAMPLES_RECEIVED'
      //   },{
      //     action:"DAI_LING_YANG"
      //   }]
      // this.task ={
      //   'orderActionData':{
      //     'futureActionAcceptableResults':['CHONG_XIN_TI_GONG_YANG_PIN','ZHONG_ZHI'],
      //     action:'LAB_SAMPLES_RECEIVED'
      //     }
      //   }
      this.loading = true
      this.$store.dispatch('getLabOrderDetail', this.id).then((response) => {
        this.loadFailed = false
        this.loading = false
        let { order, status, task, logs, sampleRecollectLogs, tasks } = response
        // order.SAMPLE_EXCEL = []// 样本随机化表RANDOM_SAMPLE_EXCEL
        // order.SampleSheet = []// SampleSheet  SAMPLE_SHEET
        // order.INSPECTION_DATA = []// 样本接收单CUSTOMER_INSPECTION_DATA
        // order.QUALITY_CONTROL_REPORT = []
        // if (order.attachments && order.attachments.length) {
        //   order.attachments.forEach(item => {
        //     item.name = item.name || (item.ossUrl && item.ossUrl.substring(item.ossUrl.lastIndexOf('/') + 1))
        //     switch (item.type) {
        //       case 'SAMPLE_SHEET':
        //         order.SampleSheet.push(item)
        //         break
        //       case 'RANDOM_SAMPLE_EXCEL':
        //         order.SAMPLE_EXCEL.push(item)// 样本随机化表RANDOM_SAMPLE_EXCEL
        //         break
        //       case 'CUSTOMER_INSPECTION_DATA':
        //         order.INSPECTION_DATA.push(item)// 样本接收单CUSTOMER_INSPECTION_DATA
        //         break
        //       case 'QUALITY_CONTROL_REPORT':
        //         order.QUALITY_CONTROL_REPORT.push(item)// 样本提取模板
        //         break
        //     }
        //   })
        // }

        this.order = order
        this.statuses = status
        this.task = task
        this.tasks = tasks
        // this.logs = logs.filter(e => e.orderActions)
        // for (let i = 0; i < this.logs.length; i++) {
        //   let log = this.logs[i]
        //   log.operationTime = formatDateObject(log.operationTime)
        //   log.orderAction = orderflowHelper.formatTargetOrderStatus(log.orderActions)

        //   if (log.orderActions === 'CREATE') {
        //     log.operationLog = '操作了' + '创建订单'
        //   } else if (log.orderStatusResult === 'QUALIFIED' && log.orderActions === 'LAB_DNA_READY') {
        //     log.operationLog = '操作了' + '样本提取成功'
        //   } else if (log.orderStatusResult === 'QUALIFIED' && log.orderActions === 'COMPLETED') {
        //     log.operationLog = '操作了' + '完成'
        //   } else if (log.orderStatusResult === 'NOT_QUALIFIED_WAIT_FUTURE_ACTION' && log.orderActions === 'LAB_DNA_READY') {
        //     log.operationLog = '操作了' + '样本提取异常'
        //   } else if (log.orderStatusResult === 'REPORT_GENERATE' && log.orderActions === 'DATA_ANALYSISED') {
        //     log.operationLog = '操作了' + '合格'
        //   } else {
        //     log.operationLog = '操作了' + formatOperationLog(log.orderStatusResult)
        //   }
        //   // REPORT_GENERATE
        // }

        this.sampleRecollectLogs = sampleRecollectLogs
        this.order.historyOrders = response.historyOrders
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true

        this.$message.error(error || '获取订单信息失败！')
      })
    },
    handleLoding (val) {
      this.loading = val
    }
  },
  created () {
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    if (!this.order) {
      this.load()
    }
  },
  mounted () {
    document.getElementsByClassName('detail-specific')[0].classList.add('lab-order-detail')
  }
}
</script>
<style lang="less">
@media screen and (max-width: 1200px) {
  .lab-order-detail {
    width: 15rem;
  }
}
</style>
